import { render, staticRenderFns } from "./MonacoNoDiffEditor.vue?vue&type=template&id=38db8864"
import script from "./MonacoNoDiffEditor.vue?vue&type=script&lang=js"
export * from "./MonacoNoDiffEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports